import linkifyHtml from "linkify-html";
import { useState } from "react";
import "../../css/journal-shared-tribe-post.css";
import { capitalizeFirstLetter } from "../../helpers/TextHelpers";
import JournalDetailModal from "../Modals/JournalDetailModal";
import parse from "html-react-parser";
import { parseLinkifiedHtmlWithVideoEmbeds } from "../../Utils/parseLinkifiedHtmlWithVideoEmbeds";

const JournalSharedTribePost = ({ post, onModalClose }) => {
  const [expanded, setExpanded] = useState(false);
  const empotionName = post?.shared_journal_emotion_name ?? "Journal";
  const sharedJournalKeywords = post?.shared_journal_keywords ?? [];
  const [showJournalModal, setShowJournalModal] = useState(false);
  const journal = {
    user_journal_id: post?.user_journal_id,
    journal_keywords: post?.shared_journal_keywords,
    empotionName: empotionName,
  };

  const handleCloseModal = () => {
    setShowJournalModal(false);
    // Trigger parent to refetch post data
    if (onModalClose) {
      onModalClose();
    }
  };

  const linkConvert = (content) => {
    return linkifyHtml(content, {
      target: "_blank",
      rel: "noopener noreferrer",
    });
  };

  const openModal = () => {
    // const event = new CustomEvent('openJournalModal', { detail: { journalId: post.shared_journal_id } });
    // window.dispatchEvent(event);
    setShowJournalModal(true);
  };

  return (
    <div
      className="journal-shared-tribe-post-container"
      style={{ marginBottom: "20px" }}
    >
      <div>
        {/* Post content */}
        <div
          className="post-text post-text-content d-flex flex-column gap-0"
          style={{
            color: "#C8CED3",
            whiteSpace: "pre-line",
            wordBreak: "break-word",
            marginBottom: "10px",
          }}
        >
          {parseLinkifiedHtmlWithVideoEmbeds(
            expanded
              ? linkConvert(post.text)
              : post.text.length > 150
                ? linkConvert(post.text.slice(0, 150) + "...")
                : linkConvert(post.text),
          )}
        </div>

        <div className="emotion-name-text">
          User shared their {empotionName} reframe. Click below to view detail.
        </div>
        {/* See more texts */}
        {post.text.length > 150 && (
          <div
            className="post-text"
            style={{ marginTop: "8px", cursor: "pointer" }}
            onClick={() => setExpanded(!expanded)}
          >
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_57395_31842)">
                <path
                  d={
                    expanded
                      ? "M12.6663 7.35547H3.33301V8.6888H12.6663V7.35547Z"
                      : "M12.6663 8.6888H8.66634V12.6888H7.33301V8.6888H3.33301V7.35547H7.33301V3.35547H8.66634V7.35547H12.6663V8.6888Z"
                  }
                  fill="#008CFF"
                />
              </g>
              <defs>
                <clipPath id="clip0_57395_31842">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.0214844)"
                  />
                </clipPath>
              </defs>
            </svg>
            <span
              style={{
                fontSize: "16px",
                color: "#008CFF",
                marginLeft: "12px",
              }}
            >
              {expanded ? "See Less" : "See More"}
            </span>
          </div>
        )}
      </div>

      <div className="tribe-journal-shared-post-box" onClick={openModal}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="tribe-journal-shared-post-view-detail">
            {parse(post?.title_answer || "No Title Provided")}
          </div>
        </div>

        <div>
          <img
            alt="arrow-icon"
            src="/icons/arrow-square-right.svg"
            style={{ width: "18px", height: "18px" }}
          />
        </div>
      </div>
      <JournalDetailModal
        isOpen={showJournalModal}
        onClose={handleCloseModal}
        journal={journal}
        tribePostShared={true}
        tribePost={post}
      />
    </div>
  );
};

export default JournalSharedTribePost;
